/**
 * 動的なスタイル操作
 */

// 最下部フッターが存在する場合のメインコンテンツの最大heightを返却
export function getMaxMainContentsHeight(footerHeight: number) {
  // 一時対応
  //  本来はvhを使用して、画面全体の高さからヘッダーやフッターの高さを引いた値を返すべき
  //  各画面の実装方法が異なるため、テストの影響を考慮し現状は100%で対応
  //  現状の個別実装に合わせてfooterの高さを引いた値を返すようにしている（未設定の場合は計算なしと同様の挙動）
  // return `calc(100vh - var(--header-height) - (var(--container-main-contents-margin) * 2) - ${footerHeight}px)`;
  return `calc(100% - ${footerHeight}px)`;
}
